<template>
  <div class="verval">
    <statistik :value="statistik"></statistik>
    <!--daftar-->
    <v-card flat>
      <v-card-title class="py-1">
        <base-table-header
          :options="{ header: 'pa-0' }"
          btn-filter
          :btn-download="$allow('psp-peserta-lulus.download')"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
          @download="onDownloadList"
        >
          <template v-slot:toolbar>
            <v-select
              class="mr-2"
              v-model="params.gelombang"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              hide-details
              @change="fetchData"
              style="max-width: 180px"
            />
          </template>
          <template v-slot:subtitle>
            <div class="subtitle-1 font-weight-medium black--text">
              Daftar Peserta Program Sekolah Penggerak
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <base-list-filter
          ref="filter"
          title="Pilih Filter Status"
          :filtered="filtered"
          :filters="formFilter"
          :paramsFilter="filters"
          @save="filterSave"
        />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-avatar class="mr-3" size="48">
                          <v-avatar color="secondary" size="65">
                            <v-img v-if="$getDeepObj(item, 'foto')" :src="$getDeepObj(item, 'foto')"></v-img>
                            <v-icon v-else dark large>mdi-account</v-icon>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <div class="secondary--text font-weight-medium subtitle-1" style="line-height: 1">
                            {{ $getDeepObj(item, 'ptk.data.nama') || '-' }}
                          </div>
                          <div class="body-2 mt-1">
                            <span class="font-weight-medium">SIMPKB ID: </span>{{ item.ptk_id || '-' }}
                          </div>
                          <div class="my-auto" style="line-height: 1" v-if="$route.meta.api === 'pelatih-ahli'">
                            <v-icon class="mr-1" color="primary" small dark left @click="onCall(item)">
                              mdi-account
                            </v-icon>
                            {{ $getDeepObj(item, 'm_unsur_psp.data.keterangan') }}
                          </div>
                          <div class="my-auto" style="line-height: 1">
                            <v-icon
                              v-if="$getDeepObj(item, 'no_wa')"
                              class="mr-1"
                              color="success"
                              small
                              dark
                              left
                              @click="onCall(item)"
                            >
                              mdi-whatsapp
                            </v-icon>
                            {{ $getDeepObj(item, 'no_wa') || $getDeepObj(item, 'ptk.data.no_hp') || '-' }}
                          </div>
                          <div v-if="+$getDeepObj(item, 'is_gugur') === 1">
                            <base-chips
                              :chip="{
                                label: 'Gugur',
                                icon: 'mdi-close',
                              }"
                              :color="'error-box'"
                            ></base-chips>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <span class="grey--text mb-1" style="font-size: 13px">
                            {{ $route.meta.api === 'pelatih-ahli' ? 'Instansi Asal' : 'Informasi Sekolah' }}
                          </span>
                          <div class="font-weight-regular" style="font-size: 15px">
                            <span>
                              {{ item.sekolah_id ? $getDeepObj(item, 'sekolah.data.nama') || '' : item.instansi_nama }}
                            </span>
                            <div class="body-2 mt-1" v-if="item.sekolah_id">
                              <span class="font-weight-bold">NPSN:</span> {{ $getDeepObj(item, 'sekolah.data.npsn') }}
                            </div>
                            <div class="body-2" v-if="item.sekolah_id">
                              <span class="font-weight-bold">Status:</span>
                              {{ +$getDeepObj(item, 'sekolah.data.is_negeri') === 1 ? 'Negeri' : 'Swasta' }}
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <span class="grey--text" style="font-size: 13px">
                            {{ $route.meta.api === 'pelatih-ahli' ? 'Alamat Instansi Asal' : 'Alamat Sekolah' }}
                          </span>
                          <div class="body-2 font-weight-regular">
                            <template v-if="item.sekolah_id">
                              <span>{{ $getDeepObj(item, 'sekolah.data.m_kota.data.keterangan') }}</span>
                              <br />Prov. {{ $getDeepObj(item, 'sekolah.data.m_propinsi.data.keterangan') }}
                            </template>
                            <template v-else>
                              <span v-if="item.instansi_k_kota">
                                {{ $getDeepObj(item, 'm_kota_instansi.data.keterangan') }}
                              </span>
                              <br v-if="item.instansi_k_kota" />
                              Prov. {{ $getDeepObj(item, 'm_propinsi_instansi.data.keterangan') }}
                            </template>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="1">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <span class="grey--text" style="font-size: 13px">Angkatan</span>
                          <div class="subtitle-1 font-weight-medium secondary--text">
                            {{ item.gelombang || '-' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <span class="grey--text" style="font-size: 13px">
                            Status
                          </span>
                          <div>
                            <template v-if="$route.meta.api !== 'pelatih-ahli'">
                              <v-chip small :class="[+item.is_aktif === 1 ? 'green' : 'red', 'white--text']">
                                {{ +item.is_aktif === 1 ? 'Pelaksana' : 'Mengundurkan Diri' }}
                              </v-chip>
                            </template>
                            <template v-else>
                              <v-chip small v-if="+item.is_aktif === 1" :class="['green', 'white--text']">
                                Pelaksana
                              </v-chip>
                              <template v-else>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-chip small v-bind="attrs" v-on="on" :class="['red white--text']">
                                      Diskualifikasi
                                    </v-chip>
                                  </template>
                                  <span> alasan: {{ item.alasan_diskualifikasi }} </span>
                                </v-tooltip>
                                <div class="py-2 error--text caption">
                                  oleh {{ $getDeepObj(getAdminDiskualifikasi(item), 'akun.data.nama') }}<br />
                                  {{
                                    $localDate(
                                      $getDeepObj(getAdminDiskualifikasi(item), 'wkt_proses'),
                                      false,
                                      true,
                                      true
                                    )
                                  }}
                                </div>
                              </template>
                            </template>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text v-if="actionsMenu.length">
                  <base-list-action :data="item" :actions="actionsMenu" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <!--modal-->
    <base-modal-full ref="modal" :title="formulir['title']" :auto-close="false" @close="onClose" @save="onSave">
      <component
        ref="formulir"
        :is="formulir['form']"
        :jenis="formulir['jenis']"
        :id="formulir['id']"
        :detail="formulir['detail']"
      ></component>
    </base-modal-full>
  </div>
</template>

<script>
import list from '@mixins/list';
import Statistik from './Statistik';
import FormAjuan from './FormAjuan';
import FormPeserta from './FormPeserta';
import BaseChips from '@components/base/BaseChips';
import mixin from '../mixin';
import actionsMenu from '../actions';
export default {
  name: 'Kasek',
  props: {
    jenis: {
      type: String,
      required: true,
    },
  },
  components: { BaseChips, Statistik, FormAjuan, FormPeserta },
  mixins: [list, mixin],
  data() {
    return {
      formulir: {},
      actionsMenu: actionsMenu['peserta'],
      listLaporan: [
        {
          key: 'download',
          label: `Laporan Daftar Peserta PSP`,
        },
      ],
      M_GUGUR: {
        1: 'Gugur',
        0: 'Tidak Gugur',
      },
    };
  },
  created() {
    this.attr = { api: this.$route.meta.api || '' };
  },
  mounted() {
    this.$set(this.params, 'gelombang', this.$getDeepObj(this.pspConfig, `peringkat.gelombang`));
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
